var React = require('react');

function Help (props) {
    return React.createElement("svg",props,React.createElement("text",{"fill":"currentColor","fillRule":"evenodd","fontFamily":"material","fontSize":"23","letterSpacing":"-.431"},React.createElement("tspan",{"x":"-5","y":"20"},"")));
}

Help.defaultProps = {"viewBox":"0 0 13 23","width":"13","height":"23"};

module.exports = Help;

Help.default = Help;
